import React, { useEffect } from 'react';
import { RouteComponentProps } from '@reach/router';
import { SidePanelNavButton } from '../../components/side-panel-nav-button';
import { View } from '../../components/view';
import { useStateValue } from '../../components/state';

interface Props extends RouteComponentProps {
  previousLocation: any;
}

export const Where: React.FC<Props> = ({ children, location, previousLocation }) => {
  const [, dispatch] = useStateValue();

  // Filter map pins to all
  useEffect(() => {
    dispatch({ type: 'setActiveMarkerSet', payload: { activeMarkerSet: 'default' } });
    dispatch({ type: 'setSidePanelFull', payload: { sidePanelFull: false } });
    dispatch({ type: 'setActiveYear', payload: { activeYear: 2019 } });

    // Zoom to home if coming from the initial search
    if (previousLocation && previousLocation.pathname === '/') {
      dispatch({ type: 'setActiveMarkerType', payload: { activeMarkerType: 'home' } });
    }
  }, [dispatch, previousLocation]);

  return (
    <View>
      {location && location.pathname !== '/where' && (
        <SidePanelNavButton href="/where">Where does Perth’s water come from?</SidePanelNavButton>
      )}
      {children}
    </View>
  );
};
